
const stringToObject = (subjectDn) => {
  const splitSubjectdn = subjectDn.split(',');
  const subjectDnArrayOfObject = splitSubjectdn.map((item) => {
    const subejctDnItem = item.split('=')
    return {
      [subejctDnItem[0].replace(/\s+/g, '')] : subejctDnItem[1]
    }
  })
  
  return  subjectDnArrayOfObject.reduce((obj, item) => {
    Object.assign(obj, {[Object.keys(item)]: Object.values(item)[0]})
    return obj
  }, {})
}

export const filterCerts = (certs) => {
  const activeCerts = certs.filter((cert) => cert.certState === "ENROLLED")
  return activeCerts.map((cert) => {
    
    return {
      id: cert.id,
      subjectdn: stringToObject(cert.subjectdn),
      issuer: stringToObject(cert.issuerdn),
      validFrom: cert.notbefore,
      validTo: cert.notafter,
      isSeal: cert.isseal
    }
  })
}

export const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = window.atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}